function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=2095&deploy=1&compid=3396259&ns-at=AAEJ7tMQm1ab32GcxTmNlNPKgFXxPFP_6262r9TLrEDRxvPZUq4","customscript_ns_sc_sl_contact_us_form_ac:customdeploy_ns_sc_sl_contact_us_form_ac":"/app/site/hosting/scriptlet.nl?script=4341&deploy=1&compid=3396259&ns-at=AAEJ7tMQVFTQ6QzPySL76FeDdwC-PajScGbR4KSe-p17hm6lXRI","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=3086&deploy=1&compid=3396259&ns-at=AAEJ7tMQM6-kZPtANnxK2KJ6HmnxlpwxiIz4-fgR1ludHA6qWOo","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=3087&deploy=1&compid=3396259&ns-at=AAEJ7tMQuUJRJZkE17W5JsP1gCnExqd5M_tBvFWED5vcFwD1atY"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}